export default function onboarded({ store})
{
    if (! store.getters["auth/onboarded"])
    {
        return 'onboarding';
    }

    return false;
}
